import { format } from 'date-fns'
import { UserIcon } from 'vlab-frontend-components'
import NotFoundCard from '../NotFoundCard'
import { phoneMask } from '../../utils/masks'
import { Pagination } from '../pagination/pagination'

interface PaginationProps {
    currentPage: number
    totalPages: number
    pageSize: number
    total: number
}

interface IFeedbackCard {
    feedbacks: {
        rate: number
        feedback: string
        feedback_at: string
    }[]
    containerClassName?: string
    pagination: PaginationProps
    setPagination: (values: PaginationProps) => void
}

function FeedbackCardAppDisabled({ feedbacks, containerClassName, pagination, setPagination }: IFeedbackCard) {
    return (
        <div className={`p-6 bg-[#F7F8FC] w-full rounded text-[12px] h-full max-h-[380px] overflow-y-hidden overflow-x-auto lg:overflow-y-auto lg:overflow-x-hidden ${containerClassName}`}>
            <p className="font-semibold text-[18px] ">Feedbacks</p>

            {feedbacks && feedbacks.length > 0 ? (
                <div className="py-2 lg:py-0  flex flex-row lg:flex-col gap-4 mt-4  lg:items-center items-start  h-[calc(100% - 20px)] lg:h-full">
                    {feedbacks.map((feedback) => {
                        const date = format(new Date(feedback.feedback_at), 'dd/MM/yyyy')
                        return (
                            <div className="w-[350px] min-w-[350px] lg:min-w-[100%] justify-between flex flex-col lg:flex-row gap-6 p-6 bg-white rounded items-center lg:w-full leading-4">
                                <div className="flex gap-4 w-full lg:w-[190px] items-center">
                                    <div>
                                        <div className="w-[32px] h-[32px] bg-[#ECF2F8] rounded-full flex items-center justify-center">
                                            <UserIcon width="16px" height="16px" color="#0166FF" />
                                        </div>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-[16px] ">{date}</p>
                                    </div>
                                </div>

                                <p className="w-full max-w-[486px]">{feedback.feedback && `“${feedback.feedback}”`}</p>

                                <div className=" flex gap-4">
                                    <div className="h-[32px] w-[1px] bg-[#DDE5EC] hidden lg:block" />
                                    <div>
                                        <p className="text-[15px] text-[#8B98A3] mt-2 w-[55px]">Nota: {feedback.rate}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    <Pagination
                        currentPage={pagination.currentPage+1}
                        pageSize={pagination.pageSize}
                        total={pagination.total}
                        totalPages={pagination.totalPages}
                        onPageChange={(page) =>
                            setPagination({ ...pagination, currentPage: page - 1 })
                        }
                    />
                </div>
            ) : (
                <div className="mt-8">
                    <NotFoundCard />
                </div>
            )}
        </div>
    )
}

export default FeedbackCardAppDisabled
